<template>
    <Notice v-if="socialLoginError" class="social-auth-error" :show-icon="true" type="error">
        <template v-if="socialLoginError === 'email_login_required'">
            {{ $t('errors.facebook_login_not_possible') }}
        </template>
        <template v-else-if="socialLoginError === 'facebook_id_already_exists'">
            {{ $t('errors.facebook_account_already_registered') }}
        </template>
        <template v-else-if="socialLoginError === 'google_id_already_exists'">
            {{ $t('errors.google_account_already_registered') }}
        </template>
        <template v-else-if="socialLoginError === 'email_required'">
            {{ $t('errors.facebook_email_grant_required') }}
        </template>
        <template v-else>
            {{ $t('errors.login_failed') }}
            {{ $t('errors.try_again_or_contact_us') }}
        </template>
    </Notice>
</template>

<script>
import Notice from '~/components/Notice';
export default {
    name: 'SocialAuthError',
    components: { Notice },
    computed: {
        socialLoginError() {
            return this.$route.query['auth-error'] || this.$route.query.error_code;
        },
    },
};
</script>

<style scoped lang="scss">
.social-auth-error {
    margin-bottom: 20px;
}
</style>
